export default class TimeController {
    constructor(onTime) {
        this.time = 0;
        this.onTime = onTime;
    }

    componentWillUnmount() {
        this.onTime = () => {};
        this.stopInterval();
    }

    AddTimeout(duration, onFinished, shouldResetTime = true) {
        this.resetTime(shouldResetTime);

        this.interval = setInterval(() => {
            this.time += 200;
            this.onTime(this.time / 1000);
        }, 200);

        return setTimeout(() => {
            this.stopInterval();
            onFinished();
        }, duration);
    }

    stopInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    AddTimeoutFromTimeline(data, cb, shouldResetTime = true, additionalMilliseconds = 660) {
        this.resetTime(shouldResetTime);

        let endTime = 0;

        Object.keys(data).forEach((key) => {
            const period = key.split('-');
            const time = parseInt(period[1], 10);

            if (time > endTime) endTime = time;
        });

        endTime += additionalMilliseconds;

        return this.AddTimeout(endTime, cb);
    }

    Add(time) {
        this.onTime(time);
    }

    resetTime = (shouldResetTime) => {
        if (shouldResetTime) this.time = 0;
    };
}
